import React from 'react';
import ReactDOM from 'react-dom';
import styles from '../Onboarding.module.css';
import * as utils from '../../../utils/utils';
import HQDialog from '../../HQDialog/HQDialog';
import { FiCheck, FiX } from 'react-icons/fi';

export default class OnboardingNickname extends React.Component {

    constructor(props) {
        super(props);

        this.defaultMessage = 'Nickname must be 3-20 characters, and can only contain letters, numbers, and underscores.';

        this.state = {
            nickname: '',
            isCheckingAvailability: false,
            isAvailable: null,
            isSaving: false,
            errorText: '',
        };

        this.availabilityCheckTimeout = null;
    };

    componentDidMount() {
        if (!utils.isLoggedIn()) {
            window.location.href = '/signin';
            return;
        }
    };

    componentWillUnmount() {
        clearTimeout(this.availabilityCheckTimeout);
    };

    getErrorMessage = (error, fallbackText) => {
        if (error && typeof error === 'object' && typeof error.message === 'string' && error.message.trim() !== '') {
            return error.message;
        }

        if (typeof error === 'string' && error.trim() !== '') {
            return error;
        }

        return fallbackText;
    };

    isValidNickname = (nickname) => {
        return !(
            nickname.length < 3 ||
            nickname.length > 20 ||
            !/^[a-zA-Z0-9_]+$/.test(nickname)
        );
    };

    onNicknameChange = (value) => {
        clearTimeout(this.availabilityCheckTimeout);

        this.setState({
            nickname: value.toLowerCase(),
            isAvailable: null,
            errorText: '',
        });

        if (!this.isValidNickname(value)) {
            return;
        }

        this.availabilityCheckTimeout = setTimeout(() => {
            this.checkAvailability(value);
        }, 400);
    };

    checkAvailability = async (nickname) => {
        this.setState({
            isCheckingAvailability: true
        });

        try {
            const response = await utils.sendRequest('/auth/isNicknameAvailable', { nickname });

            if (this.state.nickname !== nickname) {
                return;
            }

            this.setState({
                isCheckingAvailability: false,
                isAvailable: !!(response && response.isAvailable),
            });
        }
        catch (error) {
            console.log('check nickname availability error', error);

            if (this.state.nickname !== nickname) {
                return;
            }

            this.setState({
                isCheckingAvailability: false,
                isAvailable: null,
            });
        }
    };

    saveNicknameAndContinue = async () => {
        if (this.state.isSaving) {
            return;
        }

        const { nickname } = this.state;

        if (!this.isValidNickname(nickname)) {
            this.setState({ errorText: 'Nickname must be 3-20 characters, and can only contain letters, numbers, and underscores.' });
            return;
        }

        this.setState({
            isSaving: true,
            errorText: '',
        });

        try {
            await utils.sendRequest('/auth/saveNickname', { nickname });

            utils.setUserNickname(nickname);

            this.setState({
                isSaving: false,
                errorText: '',
            }, this.props.onContinue);
        }
        catch (error) {
            console.log('save nickname error', error);
            this.setState({
                isSaving: false,
                errorText: this.getErrorMessage(error, 'Could not save nickname. Please try again.'),
            });
        }
    };

    renderAvailabilityStatus = () => {
        const { isCheckingAvailability, isAvailable } = this.state;

        if (isCheckingAvailability) {
            return <p className={styles.helperText}>Checking availability...</p>;
        }

        if (isAvailable === true) {
            return <p className={`${styles.availabilityStatus} ${styles.availabilityAvailable}`}><FiCheck /> This nickname is available</p>;
        }

        if (isAvailable === false) {
            return <p className={`${styles.availabilityStatus} ${styles.availabilityTaken}`}><FiX /> This nickname is taken</p>;
        }

        return null;
    };

    render() {
        const {
            nickname,
            isSaving,
            errorText,
        } = this.state;

        return (
            <>

                <h2 className={styles.formTitle}>Pick Your Nickname</h2>
                <p className={styles.formText}>{this.defaultMessage}</p>

                <div className={styles.form}>
                    <div className={styles.fieldGroup}>
                        {/* <label className={styles.label} htmlFor='nickname-input'>Nickname</label> */}
                        <div className={styles.nicknameInputRow}>
                            <span className={styles.nicknameInputPrefix}>hqvibe.com/@</span>
                            <input
                                type='text'
                                id='nickname-input'
                                className={styles.nicknameInput}
                                placeholder='nickname'
                                value={nickname}
                                onChange={(event) => this.onNicknameChange(event.target.value)}
                                disabled={isSaving}
                                autoComplete='off'
                                autoCorrect='off'
                                autoCapitalize='off'
                            />
                        </div>
                        {this.renderAvailabilityStatus()}
                    </div>

                    <button
                        className={styles.primaryButton}
                        type='button'
                        onClick={this.saveNicknameAndContinue}
                        disabled={isSaving}
                    >
                        {isSaving ? 'Saving...' : 'Continue'}
                    </button>
                </div>

                {
                    errorText !== '' &&
                    <div className={styles.errorBox}>{errorText}</div>
                }
            </>
        );
    };

}
